import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Card from './form/Card.js';
import Notification from '../../components/Notification.js'
import General from '../../modules/General.js';
import {setGlobalKey} from '../../actions/General';

class BillingDealer extends React.Component {
    constructor(props) {
        super(props);



    }

    componentWillMount() {
        if(!this.props.general.account.dealer) {
            this.props.router.push(General.Link('/settings/billing/subscribe'));
        }
    }

    getPlanStatus = (plan) => {
        if(plan.ends_at && plan.ends_at != '') {
            return 'Cancelled. Ends at: '+plan.ends_at;
        }

        return 'Active';
    }

    render() {

        if(!this.props.general.account.dealer) {
            return <span></span>;
        }



        return (

            <div className="full-height">
                <div className="page-content">

                    <div className="row">
                        <div className="col-sm-6 offset-sm-3">
                            <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                                <div className="panel-heading">
                                    <h3 className="panel-title">Dealer</h3>
                                </div>
                                <div className="panel-body">
                                    {
                                        this.props.general.account.expired == true ?
                                            <div role="alert" className="alert dark alert-danger alert-dismissible">
                                                <h4>Subscription expired</h4>
                                                <p>
                                                    Your subscription has expired. To continue using our service you need to subscribe.
                                                    <br />
                                                    You must contact your dealer to subscribe.
                                                </p>
                                            </div>:null
                                    }

                                    Your account is managed by <strong>{this.props.general.account.dealer.name}</strong>. Please contact them regarding billing issues, support and other questions.<br /><br />

                                    <h5>Contact information</h5>
                                    <strong>E-mail:</strong> {this.props.general.account.dealer.email}<br />
                                    <strong>Phone:</strong> {this.props.general.account.dealer.phone}
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        this.props.general.plans.length > 0 ?
                            <div className="row">
                                <div className="col-sm-6 offset-sm-3">
                                    <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                                        <div className="panel-heading">
                                            <h3 className="panel-title">Your subscriptions</h3>
                                        </div>
                                        <div className="panel-body">
                                            <table className="table">
                                            {
                                                this.props.general.plans.map((plan) => {
                                                    return (
                                                        <tr key={plan.plan.id}>
                                                            <td><strong>{plan.details.name}</strong></td>
                                                            <td>{this.getPlanStatus(plan.plan)}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>:null
                    }


                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setGlobalKey},dispatch)
}


BillingDealer = connect(mapStateToProps,mapDispatchToProps)(BillingDealer);
export default BillingDealer;



// WEBPACK FOOTER //
// ./containers/settings/BillingDealer.js